import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Eye } from "@phosphor-icons/react";

/**
 * Renders a masked phone with an inline "reveal" button.
 * On click, calls POST /api/leads/{id}/reveal-phone, receives full number,
 * shows it inline. Every reveal is audit-logged + rate-limited server-side.
 *
 * Admin: server already returns full phone; no button shown.
 */
export default function PhoneCell({ lead, onRevealed }) {
  const [revealing, setRevealing] = useState(false);
  const isMasked = !!lead.phone_masked;
  const value = lead.phone || "—";

  const reveal = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setRevealing(true);
    try {
      const { data } = await api.post(`/leads/${lead.id}/reveal-phone`);
      onRevealed?.(data.phone);
      toast.success("Phone revealed · logged");
    } catch (err) {
      toast.error(formatApiError(err));
    }
    setRevealing(false);
  };

  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`phone-cell-${lead.id}`}>
      <span className="font-mono">{value}</span>
      {isMasked && (
        <button
          onClick={reveal}
          disabled={revealing}
          title="Reveal full number (this action is logged)"
          data-testid={`reveal-phone-${lead.id}`}
          className="inline-flex items-center justify-center w-5 h-5 border border-border hover:bg-secondary hover:border-primary transition-colors disabled:opacity-50"
        >
          <Eye size={11} />
        </button>
      )}
    </span>
  );
}
